/**
 * Personnel Storage Service Factory
 *
 * Wraps the infrastructure storage accessors so presentation hooks consume
 * session/filter storage through composition instead of importing infrastructure.
 *
 * @module @personnel/composition/factories/createPersonnelStorage
 */

import type { PersonnelStorage } from '@personnel/composition/types';

import { getCurrentUserUuid } from '@personnel/infrastructure/storage/currentUserUuid';
import { getCurrentOrganizationUudi } from '@personnel/infrastructure/storage/currentOrganization';
import {
  saveEmployeeFilters,
  loadEmployeeFilters,
  removeEmployeeFilters,
  hasEmployeeFilters,
} from '@personnel/infrastructure/storage/employeeFiltersStorage';

/**
 * Assembles the personnel storage service.
 * These accessors read browser storage (infrastructure); exposing them here
 * keeps localStorage access out of the presentation layer.
 *
 * @returns Storage service exposed to presentation
 */
export const createPersonnelStorage = (): PersonnelStorage => ({
  getCurrentUserUuid,
  getCurrentOrganizationUuid: getCurrentOrganizationUudi,
  saveEmployeeFilters,
  loadEmployeeFilters,
  removeEmployeeFilters,
  hasEmployeeFilters,
});
